export default "En gal kunstner har stjålet et værdifuldt maleri og truer med at ødelægge det. Kan I redde det, før det går tabt for evigt?";